var e={tag:"tag--PlkLP",grey:"grey--BpetQ",quiet:"quiet--38R1O",loud:"loud--M6Bnz",yellow:"yellow--XOyUo",green:"green--z4aRi",red:"red--5LxUL",blue:"blue--usWK4"};export{e as default};
//# sourceMappingURL=index.module.scss.js.map
